import styled from "styled-components";
import { GroupBase, StylesConfig } from "react-select";

import { IOption } from "../../interfaces/select";

export const styles: StylesConfig<IOption, boolean, GroupBase<IOption>> = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "4px",
    border: `1px solid ${
      !state.isDisabled ? "var(--input-border)" : "var(--input-disabled-border)"
    }`,

    backgroundColor: !state.isDisabled
      ? "transparent"
      : "var(--input-disabled-background)",

    boxShadow: "none",

    minHeight: "40px",
    outline: 0,

    marginTop: "8px",
    padding: "0",

    display: "flex",
    alignItems: "center",

    ":focus-within": {
      boxShadow: "var(--input-focus-shadow)",
    },

    ":hover": {
      borderColor: "var(--input-hover-border)",
      boxShadow: "none",
    },
  }),
  valueContainer: () => ({
    padding: "4px 16px",
    display: "flex",
    flex: "1",
    flexWrap: "wrap",
  }),
  indicatorSeparator: () => ({}),
  indicatorsContainer: (provided) => ({
    ...provided,
    "& svg": {
      fill: "var(--input-color)",
    },
  }),
  dropdownIndicator: () => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 16px",
  }),
  menu: (provided) => ({
    ...provided,
    border: 0,
    boxShadow: "none",
    outline: 0,
    padding: 0,
    WebkitBoxShadow: "var(--shadow)",
  }),
  placeholder: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
  }),
  singleValue: () => ({
    color: "var(--input-color)",
    display: "flex",
    alignItems: "center",
  }),
  multiValue: () => ({
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--select-multivalue-background)",
    borderRadius: "4px",
    margin: "4px",
    minHeight: "32px",
    fontSize: "1rem",
  }),
  multiValueLabel: () => ({
    padding: "2px 6px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    height: "100%",

    transition: "0.2s",
  }),
  option: (provided, state) => ({
    ...provided,
    minHeight: "40px",
    backgroundColor: state.isSelected
      ? "var(--select-option-selected)"
      : "transparent",
    color: "var(--select-option-color)",
    boxShadow: "none",
    transition: "0.2s",

    ":hover": {
      backgroundColor: "var(--select-option-hover-background)",
      color: "var(--select-option-hover-color)",
    },

    "&:disabled": {
      backgroundColor: "var(--select-option-disabled)",
    },
  }),
};

export const Container = styled.div`
  &.error {
    & > div > div {
      border-color: var(--input-error) !important;
    }
  }

  &.validate {
    & > div > div {
      border-color: var(--input-success) !important;
    }
  }

  &.verifying {
    & > div > div {
      border-color: var(--input-verifying) !important;
    }
  }
`;
